export const getVimeoEmbedURL = (videoId, unlistedHash) => {
    return `https://player.vimeo.com/video/${videoId}${unlistedHash ? `?h=${unlistedHash}` : ''}`;
};
